"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const use_debounce_1 = require("use-debounce");
const windowDims = () => ({
    height: window.innerHeight,
    width: window.innerWidth,
});
exports.WindowDimensionsCtx = react_1.createContext(windowDims());
const WindowDimensionsProvider = ({ children }) => {
    const [dimensions, setDimensions] = react_1.useState(windowDims());
    const [handleResize] = use_debounce_1.useDebouncedCallback(() => setDimensions(windowDims()), 30 // delay in ms
    );
    react_1.useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => { window.removeEventListener('resize', handleResize); };
    }, []);
    return (react_1.default.createElement(exports.WindowDimensionsCtx.Provider, { value: dimensions }, children));
};
exports.default = WindowDimensionsProvider;
exports.useWindowDimensions = () => {
    return react_1.useContext(exports.WindowDimensionsCtx);
};
